export enum ApprovedSeriesProperties {
  Series = 'series',
  SeriesId = 'seriesId',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Seasons = 'seasons',
  ProcessedSeries = 'processedSeries',
}
export enum ApprovedSeriesMetaProperties {}
